var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['base-textinput-container', ..._vm.styles]},[_c('input',_vm._g(_vm._b({ref:"inputElement",attrs:{"type":"email","placeholder":_vm.placeholder,"maxlength":_vm.maxLength,"pattern":"^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.textInputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }